export default __webpack_public_path__ + "static/media/search.02db74dd.svg";